import { Show, For, createMemo } from 'solid-js';
import useWidgetData from './useWidgetData.js';
import { qty, relTime } from '../lib/format.js';

/**
 * Live tail of the metrics ring buffer. Shows the most recent N errors
 * with status, method, URL, and message.
 */
function statusClass(s) {
  const n = Number(s) || 0;
  if (n >= 500) return 'v2-err-row__status--5xx';
  if (n >= 400) return 'v2-err-row__status--4xx';
  return 'v2-err-row__status--other';
}

export function RecentErrorsPanel(props) {
  const limit = () => Math.min(Math.max(props.settings?.limit || 15, 1), 25);
  const { data, loading, error, refetch } = useWidgetData('recent-errors',
    () => ({ limit: limit() }));
  const errs = createMemo(() => data()?.errors || []);

  return (
    <div class={`v2-system-panel v2-system-panel--errors ${props.class || ''}`}>
      <div class="v2-widget-hdr">
        <span class="v2-widget-hdr__sub">total {qty(data()?.total || 0)}</span>
        <button class="v2-widget-hdr__btn" style={{ 'margin-left': 'auto' }} title="Refresh" onClick={() => refetch()}>↻</button>
      </div>
      <Show when={!loading()} fallback={<div class="v2-widget-skel">Loading…</div>}>
        <Show when={!error()} fallback={<div class="v2-error">{error()}</div>}>
          <Show when={errs().length} fallback={<div class="v2-empty">No errors recorded. ✓</div>}>
            <div class="v2-widget__scroll">
              <ul class="v2-err-list">
                <For each={errs()}>{(e) => (
                  <li class="v2-err-row" title={e.stack || ''}>
                    <span class={`v2-err-row__status ${statusClass(e.status)}`}>{e.status || '—'}</span>
                    <div class="v2-err-row__body">
                      <div class="v2-err-row__head">
                        <span class="v2-err-row__method">{e.method || 'GET'}</span>
                        <span class="v2-err-row__url" title={e.url}>{e.url}</span>
                        <span class="v2-err-row__time">{relTime(e.at)}</span>
                      </div>
                      <div class="v2-err-row__msg">{e.message || ''}</div>
                    </div>
                  </li>
                )}</For>
              </ul>
            </div>
          </Show>
        </Show>
      </Show>
    </div>
  );
}

export default function RecentErrors(props) {
  return <RecentErrorsPanel {...props} class="v2-widget" />;
}
